// extracted by mini-css-extract-plugin
export var entityChip = "_su-0";
export var entityChipMissing = "_su-1";